import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CourseCard from "./CourseCard";
import "./Courses.css";
import Paginations from "./Pagination";
import { Fade, Slide } from "react-awesome-reveal";

const courses1 = [
  {
    id: 1,
    title: "Python for Everybody Specialization",
    image: "https://a.storyblok.com/f/168723/1640x900/6132fdbe9a/cover-14.png/m/640x0",
    rating: 4.3,
    reviews: 1991,
    lessons: 6,
    duration: "22h 0m",
    level: "Beginner",
    quizzes: 50,
    certifications: "Yes",
    graduation: "10K",
    author: "Jane Cooper",
    originalPrice: 199,
    discountedPrice: 79,
    description: "A beginner-friendly series to master Python programming and data manipulation.",
    features: [
      "Step-by-step introduction to Python syntax and programming basics.",
      "Focus on data analysis and visualization techniques.",
      "Covers working with databases and web data.",
      "Includes capstone projects for real-world application."
    ],
    skills: [
      "Bridging design-development workflows.",
      "Managing Code Reusability and Components",
      "Understanding and Implementing Design Patterns",
      "Building Responsive and Efficient UIs"
    ],
    curriculum: [
      {
        title: "Introduction to Python",
        lessons: [
          "Getting started with Python",
          "Understanding basic syntax",
          "Variables and Data types"
        ]
      },
      {
        title: "Data Structures and Algorithms",
        lessons: [
          "Lists and Dictionaries",
          "Using loops and conditionals",
          "Understanding algorithms"
        ]
      }
    ],
    instructors: [
      {
        name: "John Doe",
        expertise: "Python, Data Analysis",
        experience: "10+ years",
        bio: "John is an expert in Python programming with extensive experience in teaching and industry projects.",
        pastWork: "Developed interactive applications for e-commerce, media, and tech companies."
      }
    ]
  },
  {
    id: 2,
    title: "Complete Python Bootcamp",
    image: "https://img-c.udemycdn.com/course/750x422/567828_67d0.jpg",
    rating: 4.7,
    reviews: 1563,
    lessons: 8,
    duration: "25h 0m",
    level: "Intermediate",
    quizzes: 65,
    certifications: "Yes",
    graduation: "12K",
    author: "John Smith",
    originalPrice: 250,
    discountedPrice: 100,
    description: "A comprehensive course covering Python basics to advanced topics like OOP and web development.",
    features: [
      "Teaches Python from beginner to advanced levels.",
      "Includes hands-on coding exercises and projects.",
      "Covers topics like OOP, Flask, and Django for web development.",
      "Practical implementation of Python in automation and data handling."
    ],
    skills: [
      "Bridging design-development workflows",
      "Managing Code Reusability and Components",
      "Understanding and Implementing Design Patterns",
      "Building Responsive and Efficient UIs"
    ],
    curriculum: [
      {
        title: "Core Python Concepts",
        lessons: [
          "Data types and operations",
          "Error handling",
          "Working with files"
        ]
      },
      {
        title: "Web Development with Django",
        lessons: [
          "Setting up Django environment",
          "Creating views and templates",
          "Building a full-stack web application"
        ]
      }
    ],
    instructors: [
      {
        name: "Emily Davis",
        expertise: "Python, Web Development",
        experience: "8+ years",
        bio: "Emily specializes in Python-based web applications and has built scalable systems for startups.",
        pastWork: "Developed interactive web applications for e-commerce, media, and tech companies."
      }
    ]
  }
  ,
  {
    id: 3,
    title: "Java Programming and Software Engineering Fundamentals",
    image: "https://media.licdn.com/dms/image/D5612AQE__0vcZENxpg/article-cover_image-shrink_720_1280/0/1661259693305?e=2147483647&v=beta&t=LwkMhFgEgAJxthl4Yk2mysq9BgUe89ndwOZcCIFzOLc",
    rating: 4.8,
    reviews: 2300,
    lessons: 12,
    duration: "40h 0m",
    level: "Advanced",
    quizzes: 80,
    certifications: "Yes",
    graduation: "15K",
    author: "Emily Johnson",
    originalPrice: 350,
    discountedPrice: 150,
    description: "A foundational course for Java programming and essential software engineering concepts.",
    features: [
      "Basics of Java programming language and its syntax.",
      "Emphasis on software engineering principles.",
      "Hands-on projects to build problem-solving skills.",
      "Prepares learners for advanced Java and software design."
    ],
    skills: [
      "Understanding Java Syntax and OOP Concepts",
      "Working with Data Structures and Algorithms",
      "Mastering Software Engineering Principles",
      "Building Efficient Java Applications"
    ],
    curriculum: [
      {
        title: "Introduction to Java",
        lessons: [
          "Java basics and setup",
          "Understanding object-oriented programming",
          "Writing your first Java application"
        ]
      },
      {
        title: "Advanced Java Topics",
        lessons: [
          "Multithreading and concurrency",
          "Data structures in Java",
          "Design patterns in Java"
        ]
      },
      {
        title: "Software Engineering Principles",
        lessons: [
          "Software development lifecycle",
          "Testing and debugging",
          "Version control with Git"
        ]
      }
    ],
    instructors: [
      {
        name: "James Taylor",
        expertise: "Java, Software Engineering",
        experience: "12+ years",
        bio: "James is an experienced software engineer who has worked on enterprise-level applications and frameworks.",
        pastWork: "Worked on large-scale systems for e-commerce, finance, and telecommunications."
      }
    ]
  }
  ,
  {
    id: 4,
    title: "Complete Java Masterclass",
    image: "https://www.icertglobal.com/images/What-is-Java.webp",
    rating: 4.9,
    reviews: 1800,
    lessons: 10,
    duration: "30h 0m",
    level: "Intermediate",
    quizzes: 80,  // Added quizzes
    certifications: "Yes",  // Added certifications
    graduation: "15K",  // Added graduation
    author: "Mike Brown",
    originalPrice: 400,  // Changed to a number for consistency
    discountedPrice: 170,  // Changed to a number for consistency
    description: "An in-depth guide to mastering Java programming, from core to advanced features.",
    features: [
      "Comprehensive coverage of Java fundamentals and advanced topics.",
      "Deep dive into multithreading, collections, and design patterns.",
      "Hands-on projects to develop real-world Java applications.",
      "Focus on improving problem-solving and debugging skills."
    ],
    skills: [
      "Mastering Java Syntax and Object-Oriented Programming (OOP)",
      "Implementing Advanced Java Concepts like Multithreading and Collections",
      "Building Scalable and Efficient Applications",
      "Debugging and Problem-Solving Techniques"
    ],
    curriculum: [
      {
        title: "Introduction to Java",
        lessons: [
          "Understanding Java syntax",
          "Object-Oriented Programming (OOP) basics",
          "Setting up Java development environment"
        ]
      },
      {
        title: "Advanced Java Concepts",
        lessons: [
          "Working with multithreading",
          "Java Collections framework",
          "Design patterns in Java"
        ]
      },
      {
        title: "Java Projects and Debugging",
        lessons: [
          "Building real-world applications in Java",
          "Common debugging techniques and tools",
          "Optimizing Java applications"
        ]
      }
    ],
    instructors: [
      {
        name: "Mike Brown",
        expertise: "Java, Software Engineering",
        experience: "12+ years",
        bio: "Mike is a senior Java developer with a focus on building high-performance enterprise applications.",
        pastWork: "Led teams to deliver large-scale applications for banking and e-commerce industries."
      }
    ]
  }
  ,
  {
    id: 5,
    title: "Modern React with Redux",
    image: "https://xpertlab.com/wp-content/uploads/2024/10/reactjs_img-copy.jpg",
    rating: 4.5,
    reviews: 1200,
    lessons: 15,
    duration: "35h 0m",
    level: "Beginner",
    quizzes: 40,
    certifications: "Yes",
    graduation: "8K",
    author: "Sara Lee",
    originalPrice: 299,
    discountedPrice: 120,
    description: "A practical course to build dynamic web apps using React and state management with Redux.",
    features: [
      "Introduction to React and JSX for building user interfaces.",
      "Covers Redux for state management in complex apps.",
      "Hands-on projects, including creating dynamic web apps.",
      "Emphasis on modern React features like hooks and functional components."
    ],
    skills: [
      "Building dynamic web applications with React",
      "State management with Redux",
      "Understanding and using React hooks",
      "Creating reusable components and hooks"
    ],
    curriculum: [
      {
        title: "Introduction to React",
        lessons: [
          "Setting up the React environment",
          "JSX syntax and basic components",
          "Handling events in React"
        ]
      },
      {
        title: "State Management with Redux",
        lessons: [
          "Introduction to Redux",
          "Creating actions and reducers",
          "Integrating Redux with React",
          "Managing state with Redux Toolkit"
        ]
      },
      {
        title: "React Hooks and Advanced Features",
        lessons: [
          "Understanding React hooks",
          "Using `useState`, `useEffect`, and custom hooks",
          "Optimizing performance with memoization"
        ]
      }
    ],
    instructors: [
      {
        name: "Sara Lee",
        expertise: "React, Redux, JavaScript",
        experience: "8+ years",
        bio: "Sara is a senior React developer with deep expertise in building large-scale applications using React and Redux.",
        pastWork: "Worked on enterprise-level applications in e-commerce, healthcare, and social media domains."
      }
    ]
  }
  ,
  {
    id: 6,
    title: "React - The Complete Guide",
    image: "https://miro.medium.com/v2/resize:fit:680/1*RDN058L5gQ02Xy13OaxjnQ.jpeg",
    rating: 4.6,
    reviews: 1400,
    lessons: 10,
    duration: "28h 0m",
    level: "Intermediate",
    quizzes: 65, // Added quizzes field
    certifications: "Yes", // Added certifications field
    graduation: "8K", // Added graduation field
    author: "David Clark",
    originalPrice: 320, // Changed to numeric value
    discountedPrice: 135, // Changed to numeric value
    description: "A thorough exploration of React, including hooks, context, and advanced concepts.",
    features: [
      "Detailed coverage of React basics, including components and props.",
      "Advanced concepts like hooks, context API, and error boundaries.",
      "Focus on building scalable and maintainable React applications.",
      "Real-world projects and best practices for React development."
    ],
    skills: [
      "Mastering React components and props",
      "Understanding React hooks and context API",
      "Building scalable React applications",
      "Debugging and managing error boundaries"
    ], // Added skills field
    curriculum: [
      {
        title: "Introduction to React",
        lessons: [
          "Setting up a React app",
          "Understanding JSX and rendering components",
          "React components and props"
        ]
      },
      {
        title: "React State and Lifecycle",
        lessons: [
          "Using state in React components",
          "Handling events in React",
          "React lifecycle methods"
        ]
      },
      {
        title: "React Hooks",
        lessons: [
          "Understanding useState and useEffect",
          "Using custom hooks in React",
          "Managing state with useReducer"
        ]
      },
      {
        title: "Advanced React Concepts",
        lessons: [
          "Using Context API for state management",
          "Error boundaries in React",
          "Optimizing React performance"
        ]
      }
    ], // Added curriculum field with multiple sections
    instructors: [
      {
        name: "David Clark",
        expertise: "React, Front-End Development",
        experience: "8+ years",
        bio: "David is a senior front-end developer specializing in React, with a focus on building scalable web applications.",
        pastWork: "Developed enterprise-level React applications for major tech companies and startups."
      }
    ] // Added instructors field with detailed bio
  }
  ,
  {
    id: 7,
    title: "Full-Stack Web Development with React and Node.js",
    image: "https://www.mindinventory.com/blog/wp-content/uploads/2022/03/react-nodejs.webp",
    rating: 4.7,
    reviews: 2100,
    lessons: 9,
    duration: "24h 0m",
    level: "Advanced",
    quizzes: 60,
    certifications: "Yes",
    graduation: "12K",
    author: "Anna Davis",
    originalPrice: 350,
    discountedPrice: 160,
    description:
      "Learn to build full-stack applications using React for the frontend and Node.js for the backend.",
    features: [
      "Comprehensive coverage of both frontend and backend development.",
      "Focus on React for dynamic UI and Node.js for server-side logic.",
      "Integration of databases like MongoDB.",
      "Build full-stack projects, including RESTful APIs."
    ],
    skills: [
      "Building scalable full-stack web applications.",
      "Integrating frontend React components with backend APIs.",
      "Understanding RESTful API design and development.",
      "Managing databases with MongoDB and Mongoose."
    ],
    curriculum: [
      {
        title: "Frontend Development with React",
        lessons: [
          "Introduction to React and JSX",
          "Managing state with hooks and context",
          "Building reusable UI components"
        ]
      },
      {
        title: "Backend Development with Node.js",
        lessons: [
          "Setting up a Node.js server with Express",
          "Connecting to MongoDB using Mongoose",
          "Building and securing RESTful APIs"
        ]
      }
    ],
    instructors: [
      {
        name: "Anna Davis",
        expertise: "Full-Stack Development, React, Node.js",
        experience: "8+ years",
        bio:
          "Anna is a seasoned full-stack developer with expertise in React and Node.js. She has successfully built and deployed scalable web applications for startups and enterprises.",
        pastWork:
          "Developed end-to-end solutions for e-commerce platforms, SaaS products, and financial applications."
      }
    ]
  }
  ,
  {
    id: 8,
    title: "C++ for Programmers",
    image: "https://i.pinimg.com/originals/d5/0b/03/d50b039d337efb00c2fb4b80707e1c0d.jpg",
    rating: 4.6,
    reviews: 1600,
    lessons: 8,
    duration: "25h 0m",
    level: "Beginner",
    quizzes: 60,
    certifications: "Yes",
    graduation: "15K",
    author: "Sophia Walker",
    originalPrice: 280,
    discountedPrice: 115,
    description: "A course focused on C++ programming fundamentals and advanced features for experienced coders.",
    features: [
      "Covers core C++ syntax and object-oriented programming.",
      "Advanced topics like templates, STL, and memory management.",
      "Designed for programmers transitioning to C++.",
      "Practical exercises and projects to master C++ skills."
    ],
    skills: [
      "Understanding C++ syntax and semantics.",
      "Mastering object-oriented programming concepts.",
      "Implementing advanced C++ features like STL and templates.",
      "Writing memory-efficient and optimized code."
    ],
    curriculum: [
      {
        title: "Getting Started with C++",
        lessons: [
          "Introduction to C++ and its applications",
          "Setting up the development environment",
          "Basic syntax and data types"
        ]
      },
      {
        title: "Object-Oriented Programming in C++",
        lessons: [
          "Understanding classes and objects",
          "Inheritance and polymorphism",
          "Encapsulation and abstraction"
        ]
      },
      {
        title: "Advanced Topics in C++",
        lessons: [
          "Using the Standard Template Library (STL)",
          "Working with templates and generics",
          "Effective memory management with pointers"
        ]
      }
    ],
    instructors: [
      {
        name: "Sophia Walker",
        expertise: "C++, Object-Oriented Programming",
        experience: "12+ years",
        bio: "Sophia is a seasoned software engineer with deep expertise in C++ programming. She has mentored hundreds of developers and contributed to large-scale projects in gaming and system software.",
        pastWork: "Developed high-performance gaming engines and enterprise-grade system tools."
      }
    ]
  }
  ,

];

const courses = [
  {
    id: 1,
    title: "Java Full Stack Development",
    image: "https://img.freepik.com/free-vector/hand-drawn-flat-design-api-illustration_23-2149365021.jpg?t=st=1742119189~exp=1742122789~hmac=3a69add414c529a92d0e26c246a6fbddec7c5a1fa005882f834dca7e733fd12d&w=826",
    rating: 4.8,
    reviews: 2200,
    lessons: 14,
    duration: "45h 0m",
    level: "Advanced",
    quizzes: 85,
    certifications: "Yes",
    graduation: "18K",
    author: "Haritha Mohan",
    originalPrice: 400,
    discountedPrice: 180,
    description: "Master Java Full Stack Development with Spring Boot, React, and Microservices.",
    features: [
      "Comprehensive coverage of Java, Spring Boot, and Microservices.",
      "Full-stack application development using React and Node.js.",
      "Database management with MySQL and MongoDB.",
      "Real-world projects and hands-on coding exercises."
    ],
    skills: [
      "Java and Spring Boot Framework",
      "Full-Stack Application Development",
      "Microservices Architecture",
      "Database Integration"
    ],
    curriculum: [
      {
        title: "Core Java and OOP Concepts",
        lessons: [
          "Frontend: HTML, CSS, JavaScript, React/Angular",
          "Backend: Java, Spring Boot, REST APIs",
          "Database: MySQL, PostgreSQL, MongoDB",
          "Deployment: Docker, Kubernetes, AWS"
        ]
      },
    ],
    curriculumFile: "/coursepdf/JavaFullStack.pdf",
    instructors: [
      {
        name: "Robert King",
        expertise: "Java, Microservices",
        experience: "15+ years",
        bio: "Robert is a Java architect specializing in enterprise solutions and cloud-based applications.",
        pastWork: "Built scalable Java applications for Fortune 500 companies."
      }
    ]
  },
  {
    id: 2,
    title: "Full Stack Development (MERN/MEAN Stack)",
    image: "https://img.freepik.com/free-photo/programming-background-collage_23-2149901785.jpg?t=st=1742119241~exp=1742122841~hmac=b0bd0fc0c9fb1a89ade08d4caf4800a10e4597b46fae7ee188240da819c62d8f&w=1060",
    rating: 4.7,
    reviews: 2000,
    lessons: 12,
    duration: "40h 0m",
    level: "Intermediate",
    quizzes: 70,
    certifications: "Yes",
    graduation: "16K",
    author: "Kumar",
    originalPrice: 350,
    discountedPrice: 150,
    description: "A hands-on guide to building full-stack applications using MERN and MEAN stacks.",
    features: [
      "Learn MongoDB, Express.js, React, and Node.js.",
      "Develop single-page applications with Angular and React.",
      "Backend development with Node.js and Express.",
      "Deploying applications on cloud platforms."
    ],
    skills: [
      "Building RESTful APIs",
      "Frontend UI with React and Angular",
      "Database Integration with MongoDB & SQL",
      "Deployment and DevOps Basics"
    ],
    curriculum: [
      {
        title: "Frontend Development with React & Angular",
        lessons: [
          "Frontend: HTML, CSS, JavaScript, React/Angular",
          "Backend: Node.js, Express.js",
          "Database: MongoDB/MySQL",

        ]
      }
    ],
    curriculumFile: "/coursepdf/MEAN_MERN STACK.pdf",
    instructors: [
      {
        name: "Sophia White",
        expertise: "Full Stack Development",
        experience: "10+ years",
        bio: "Sophia has trained over 5000 students in full-stack development and worked on enterprise applications.",
        pastWork: "Built full-stack applications for fintech and e-commerce companies."
      }
    ]
  },
  {
    id: 3,
    title: "Python Programming & Machine Learning",
    image: "https://img.freepik.com/free-photo/programming-background-with-person-working-with-codes-computer_23-2150010127.jpg?t=st=1742119070~exp=1742122670~hmac=a8f42d888d8b71d538dc9dcce3f665d215f1380007df799950cbb161ac603825&w=1380",
    rating: 4.9,
    reviews: 2500,
    lessons: 18,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 90,
    certifications: "Yes",
    graduation: "20K",
    author: "Mohan",
    originalPrice: 450,
    discountedPrice: 200,
    description: "Learn Python programming and machine learning with real-world data projects.",
    features: [
      "Python fundamentals and advanced topics.",
      "Data manipulation with Pandas and NumPy.",
      "Machine Learning models using Scikit-learn.",
      "Deep Learning and TensorFlow basics."
    ],
    skills: [
      "Data Preprocessing and Cleaning",
      "Supervised and Unsupervised Learning",
      "Neural Networks and Deep Learning",
      "Python for Data Science"
    ],
    curriculum: [
      {
        title: "Python Basics and Data Handling",
        lessons: [
          "Python basics to advanced",
          "Machine Learning algorithms & models",
          "Data visualization & preprocessing",

        ]
      }
    ],
    curriculumFile: "/coursepdf/python-Syllabus.pdf",
    instructors: [
      {
        name: "Michael Harris",
        expertise: "Machine Learning, Data Science",
        experience: "12+ years",
        bio: "Michael has built AI solutions for healthcare and finance industries and teaches ML globally.",
        pastWork: "Developed AI-driven data analytics tools for Fortune 500 companies."
      }
    ]
  },
  // {
  //   id: 4,
  //   title: "Data Science & Analytics",
  //   image: "https://img.freepik.com/free-photo/business-data-analysis_53876-95296.jpg?t=st=1742119387~exp=1742122987~hmac=3522dab4272cdc84626592d0620c9ce6e78707b7b3b794ab487445ffbd285ead&w=1060",
  //   rating: 4.8,
  //   reviews: 2300,
  //   lessons: 20,
  //   duration: "55h 0m",
  //   level: "Advanced",
  //   quizzes: 95,
  //   certifications: "Yes",
  //   graduation: "22K",
  //   author: "Upendra",
  //   originalPrice: 500,
  //   discountedPrice: 220,
  //   description: "Master data science and analytics using Python, R, and real-world datasets.",
  //   features: [
  //     "Data wrangling and visualization techniques.",
  //     "Machine learning with Python and R.",
  //     "Big data processing and cloud-based analytics.",
  //     "Real-world case studies and hands-on projects."
  //   ],
  //   skills: [
  //     "Data Wrangling and Visualization",
  //     "Statistical Analysis and Modeling",
  //     "Big Data Processing with Spark",
  //     "Cloud-Based Analytics"
  //   ],
  //   curriculum: [
  //     {
  //       title: "Introduction to Data Science",
  //       lessons: [
  //         "Python, R, SQL for data analysis",
  //         "Data visualization using Power BI/Tableau",
  //         "Big Data & Cloud-based analytics",

  //       ]
  //     }
  //   ],
  //   curriculumFile: "/coursepdf/python-Syllabus.pdf",
  //   instructors: [
  //     {
  //       name: "Emily Roberts",
  //       expertise: "Data Science, Analytics",
  //       experience: "10+ years",
  //       bio: "Emily has worked on predictive analytics and AI-driven insights for Fortune 500 companies.",
  //       pastWork: "Developed machine learning models for finance and healthcare analytics."
  //     }
  //   ]
  // },
  {
    id: 5,
    title: "Artificial Intelligence & Deep Learning",
    image: "https://img.freepik.com/free-photo/engineers-brainstorming-ways-use-ai_482257-84889.jpg?t=st=1742119583~exp=1742123183~hmac=2fd8a3b5edd9e801a74c93c720af1a5730404fab19e0874d5263c30b944b8c67&w=1380",
    rating: 4.9,
    reviews: 2700,
    lessons: 20,
    duration: "55h 0m",
    level: "Advanced",
    quizzes: 100,
    certifications: "Yes",
    graduation: "22K",
    author: "Haritha Mohan",
    originalPrice: 500,
    discountedPrice: 220,
    description: "Master AI and Deep Learning concepts with hands-on projects using TensorFlow and PyTorch.",
    features: [
      "Comprehensive introduction to AI and Deep Learning.",
      "Hands-on projects with TensorFlow and PyTorch.",
      "Neural Networks, CNNs, RNNs, and GANs.",
      "Application in NLP, Computer Vision, and Reinforcement Learning."
    ],
    skills: [
      "Neural Networks and Deep Learning",
      "AI Model Training and Optimization",
      "Computer Vision and NLP",
      "Building AI-driven Applications"
    ],
    curriculum: [
      {
        title: "Introduction to AI & Deep Learning",
        lessons: ["Neural networks, TensorFlow, Keras", "Computer vision, NLP, Reinforcement Learning"]
      }
    ],
    curriculumFile: "/coursepdf/python-Syllabus.pdf",
    instructors: [
      {
        name: "Dr. Alan Turing",
        expertise: "AI, Deep Learning",
        experience: "15+ years",
        bio: "Dr. Turing is an AI researcher specializing in deep learning and neural networks.",
        pastWork: "Developed AI models for healthcare, finance, and autonomous systems."
      }
    ]
  },
  {
    id: 6,
    title: "Cloud Computing (AWS, Azure, Google Cloud)",
    image: "https://img.freepik.com/free-photo/saas-concept-collage_23-2149399281.jpg?t=st=1742119684~exp=1742123284~hmac=a7f536605a318603342f0a0fc107c818f81a7b652c8662dc11eb1f231d4421b8&w=1380",
    rating: 4.8,
    reviews: 2400,
    lessons: 16,
    duration: "45h 0m",
    level: "Intermediate",
    quizzes: 80,
    certifications: "Yes",
    graduation: "18K",
    author: "Krishna",
    originalPrice: 400,
    discountedPrice: 180,
    description: "Gain expertise in cloud computing with AWS, Azure, and Google Cloud.",
    features: [
      "Cloud fundamentals and architecture.",
      "Hands-on labs for AWS, Azure, and GCP.",
      "Deploying applications on cloud infrastructure.",
      "Security and compliance best practices."
    ],
    skills: [
      "Cloud Infrastructure Management",
      "AWS, Azure, and Google Cloud Services",
      "Cloud Security and Networking",
      "Deploying Scalable Cloud Applications"
    ],
    curriculum: [
      {
        title: "Introduction to Cloud Computing",
        lessons: ["Cloud architecture & deployment", "Security & DevOps integration", "Serverless computing"]
      }
    ],
    curriculumFile: "/coursepdf/Cloud Computing.pdf",
    instructors: [
      {
        name: "James Cloudman",
        expertise: "Cloud Computing, DevOps",
        experience: "12+ years",
        bio: "James is a cloud architect with expertise in AWS, Azure, and GCP.",
        pastWork: "Implemented cloud solutions for enterprises in banking and retail."
      }
    ]
  },
  {
    id: 7,
    title: "DevOps & CI/CD Pipelines",
    image: "https://img.freepik.com/free-vector/isometric-devops-illustration_52683-84175.jpg?t=st=1742119741~exp=1742123341~hmac=dd3391b3fa3390612de4d4f9f0f4deaf1758180e0e3ae2d4816bf4ff2d57d5cf&w=1380",
    rating: 4.7,
    reviews: 2300,
    lessons: 15,
    duration: "40h 0m",
    level: "Advanced",
    quizzes: 90,
    certifications: "Yes",
    graduation: "19K",
    author: "Haritha Mohan",
    originalPrice: 450,
    discountedPrice: 190,
    description: "Master DevOps methodologies and CI/CD pipelines with hands-on projects.",
    features: [
      "CI/CD pipeline automation.",
      "Containerization with Docker and Kubernetes.",
      "Monitoring and logging with Prometheus and Grafana.",
      "Cloud deployment and infrastructure as code (IaC)."
    ],
    skills: [
      "Continuous Integration and Deployment",
      "Docker and Kubernetes Orchestration",
      "Cloud Infrastructure as Code",
      "Monitoring and Logging in DevOps"
    ],
    curriculum: [
      {
        title: "Introduction to DevOps",
        lessons: ["Docker, Kubernetes, Terraform", "Jenkins, Git, Ansible, CI/CD automation"]
      }
    ],
    curriculumFile: "/coursepdf/DeVops-Syllabus.pdf",
    instructors: [
      {
        name: "Lisa Jenkins",
        expertise: "DevOps, Cloud Automation",
        experience: "10+ years",
        bio: "Lisa is a DevOps engineer specializing in cloud automation and CI/CD.",
        pastWork: "Designed DevOps workflows for global tech companies."
      }
    ]
  },
  {
    id: 8,
    title: "Cybersecurity & Ethical Hacking",
    image: "https://img.freepik.com/free-photo/html-css-collage-concept-with-hacker_23-2150061984.jpg?t=st=1742119810~exp=1742123410~hmac=9011a5e55ba2fe8d0a75e969b058cfc5a2b5869277731877394c2e32ebde9858&w=1380",
    rating: 4.8,
    reviews: 2500,
    lessons: 18,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 95,
    certifications: "Yes",
    graduation: "20K",
    author: "Vikas",
    originalPrice: 450,
    discountedPrice: 200,
    description: "Master the art of cybersecurity and ethical hacking with hands-on labs and real-world simulations.",
    features: [
      "Network security fundamentals and penetration testing.",
      "Ethical hacking methodologies and tools.",
      "Cloud and application security best practices.",
      "Hands-on labs and real-world attack simulations."
    ],
    skills: [
      "Network Security and Penetration Testing",
      "Ethical Hacking Techniques",
      "Cloud Security and Compliance",
      "Incident Response and Risk Management"
    ],
    curriculum: [
      {
        title: "Cybersecurity Fundamentals",
        lessons: ["Network security, penetration testing", "Ethical hacking, threat detection"]
      }
    ],
    curriculumFile: "/coursepdf/Cybersecurity & Ethical Hacking.pdf",
    instructors: [
      {
        name: "Ethan Hunt",
        expertise: "Cybersecurity, Ethical Hacking",
        experience: "12+ years",
        bio: "Ethan is a cybersecurity expert specializing in ethical hacking and penetration testing.",
        pastWork: "Secured networks for Fortune 500 companies and government agencies."
      }
    ]
  },
  {
    id: 9,
    title: "Blockchain & Web3 Development",
    image: "https://img.freepik.com/free-photo/3d-cryptocurrency-rendering-design_23-2149074561.jpg?t=st=1742119879~exp=1742123479~hmac=b7b6a71dc3b9975698fcbc5eb7f508b456486101c8f1b4e2a745d403ad234d1c&w=1060",
    rating: 4.7,
    reviews: 2300,
    lessons: 15,
    duration: "45h 0m",
    level: "Advanced",
    quizzes: 90,
    certifications: "Yes",
    graduation: "19K",
    author: "Harsha",
    originalPrice: 480,
    discountedPrice: 210,
    description: "Learn blockchain fundamentals and Web3 development with hands-on projects and smart contracts.",
    features: [
      "Understanding blockchain technology and cryptocurrencies.",
      "Smart contract development with Solidity.",
      "Building decentralized applications (DApps).",
      "Web3 integration and NFT marketplaces."
    ],
    skills: [
      "Blockchain Architecture and Cryptography",
      "Smart Contract Development with Solidity",
      "Building and Deploying DApps",
      "Tokenization and NFT Development"
    ],
    curriculum: [
      {
        title: "Blockchain Fundamentals",
        lessons: ["Smart contracts with Solidity", "Ethereum, Hyperledger, NFT development"]
      }
    ],
    curriculumFile: "/coursepdf/Blockchain & Web3 Development.pdf",
    instructors: [
      {
        name: "Satoshi Nakamoto",
        expertise: "Blockchain, Web3 Development",
        experience: "10+ years",
        bio: "Satoshi is a blockchain developer and Web3 strategist, working on decentralized finance projects.",
        pastWork: "Developed blockchain protocols and smart contracts for DeFi platforms."
      }
    ]
  },
  {
    id: 10,
    title: "Internet of Things (IoT) & Embedded Systems",
    image: "https://img.freepik.com/free-vector/internet-things-typographic-header-idea-smart-wireless-electronics-modern-global-technology-connection-devices-house-appliances-isolated-flat-vector-illustration_613284-908.jpg?t=st=1742119989~exp=1742123589~hmac=a941363cc0256dfa1a3b48bdfba31fe2455ed9b7edf3b04bd86bf5e401980032&w=1380",
    rating: 4.8,
    reviews: 2200,
    lessons: 17,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 85,
    certifications: "Yes",
    graduation: "21K",
    author: "Babu",
    originalPrice: 460,
    discountedPrice: 205,
    description: "Explore IoT and Embedded Systems with real-world applications in smart devices and automation.",
    features: [
      "Introduction to IoT architecture and protocols.",
      "Working with microcontrollers and sensors.",
      "Building IoT applications with Raspberry Pi and Arduino.",
      "Security and networking in IoT ecosystems."
    ],
    skills: [
      "IoT Device Programming and Communication",
      "Embedded Systems and Microcontrollers",
      "Cloud Integration for IoT Applications",
      "Security and Networking in IoT"
    ],
    curriculum: [
      {
        title: "IoT Fundamentals",
        lessons: ["IoT architecture, Arduino, Raspberry Pi", "IoT security & cloud integration"]
      }
    ],
    curriculumFile: "/coursepdf/Internet and IoT Systems Syllabus.pdf",
    instructors: [
      {
        name: "Elon Sparks",
        expertise: "IoT, Embedded Systems",
        experience: "14+ years",
        bio: "Elon is an IoT engineer specializing in smart systems and industrial automation.",
        pastWork: "Designed IoT solutions for smart cities and industrial automation."
      }
    ]
  },
  {
    id: 11,
    title: "Mobile App Development (Android & iOS)",
    image: "https://img.freepik.com/free-vector/app-development-banner_33099-1720.jpg?t=st=1742120050~exp=1742123650~hmac=2009f35639fb104bee188161102299983edbba0e646e813b05361a67aa908b47&w=1380",
    rating: 4.8,
    reviews: 2500,
    lessons: 18,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 85,
    certifications: "Yes",
    graduation: "20K",
    author: "Kalyan",
    originalPrice: 500,
    discountedPrice: 220,
    description: "Learn to build mobile apps for Android and iOS using React Native and Flutter.",
    features: [
      "Cross-platform development with React Native and Flutter.",
      "Building UI/UX with Material Design and Swift UI.",
      "Working with Firebase and REST APIs.",
      "Deploying apps to Google Play Store and Apple App Store."
    ],
    skills: [
      "Mobile UI/UX Design",
      "Android & iOS App Development",
      "State Management with Redux & Provider",
      "App Deployment & Performance Optimization"
    ],
    curriculum: [
      {
        title: "Introduction to Mobile Development",
        lessons: ["Flutter, React Native, Swift, Kotlin", "App deployment & performance optimization"]
      }
    ],
    curriculumFile: "/coursepdf/Mobile App Development.pdf",
    instructors: [
      {
        name: "Kevin Thompson",
        expertise: "Mobile Development, Flutter, React Native",
        experience: "10+ years",
        bio: "Kevin is a mobile app developer specializing in Android and iOS applications.",
        pastWork: "Built high-performance mobile apps for e-commerce and fintech startups."
      }
    ]
  },
  {
    id: 12,
    title: "SQL & Database Management",
    image: "https://img.freepik.com/free-vector/gradient-sql-illustration_23-2149247491.jpg?t=st=1742120101~exp=1742123701~hmac=45b43b00ed7e0a1a602cc16670764129dff3e4c2b480f4233d1d0dcaf469cef0&w=1380",
    rating: 4.7,
    reviews: 2300,
    lessons: 16,
    duration: "45h 0m",
    level: "Intermediate",
    quizzes: 75,
    certifications: "Yes",
    graduation: "18K",
    author: "Ajay",
    originalPrice: 400,
    discountedPrice: 180,
    description: "Master SQL queries, database administration, and performance optimization.",
    features: [
      "Writing efficient SQL queries and stored procedures.",
      "Database design, normalization, and indexing.",
      "Working with MySQL, PostgreSQL, and MongoDB.",
      "Database security, backup, and recovery strategies."
    ],
    skills: [
      "SQL Query Optimization",
      "Database Design & Normalization",
      "Handling Transactions & Stored Procedures",
      "Database Security & Performance Tuning"
    ],
    curriculum: [
      {
        title: "Fundamentals of SQL & Databases",
        lessons: ["MySQL, PostgreSQL, Oracle, NoSQL", "Data modeling & query optimization"]
      }
    ],
    curriculumFile: "/coursepdf/SQL & Database Management.pdf",
    instructors: [
      {
        name: "Nancy Williams",
        expertise: "Database Administration, SQL",
        experience: "12+ years",
        bio: "Nancy is a database architect with expertise in SQL, MySQL, and PostgreSQL.",
        pastWork: "Designed and optimized databases for large-scale enterprise applications."
      }
    ]
  },
  {
    id: 13,
    title: "Software Testing & Automation",
    image: "https://img.freepik.com/free-photo/standard-quality-control-concept-m_23-2150041859.jpg?t=st=1742120155~exp=1742123755~hmac=26ed2d2a0cb248a1375118939e28c79e073b8a6b7d28cca0d36ecf7a43c4b5cd&w=1380",
    rating: 4.9,
    reviews: 2600,
    lessons: 20,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 90,
    certifications: "Yes",
    graduation: "20K",
    author: "Kalyan",
    originalPrice: 450,
    discountedPrice: 200,
    description: "Learn manual and automated software testing with Selenium, JUnit, and TestNG.",
    features: [
      "Fundamentals of software testing methodologies.",
      "Automating web testing with Selenium WebDriver.",
      "API testing using Postman and RestAssured.",
      "Continuous testing in CI/CD pipelines."
    ],
    skills: [
      "Manual & Automated Testing",
      "Selenium & JUnit Testing",
      "API Testing & Performance Testing",
      "CI/CD Integration with Test Automation"
    ],
    curriculum: [
      {
        title: "Introduction to Software Testing",
        lessons: ["Selenium, JUnit, TestNG", "Manual & automated testing frameworks"]
      }
    ],
    curriculumFile: "/coursepdf/Software Testing & Automation.pdf",
    instructors: [
      {
        name: "David Reynolds",
        expertise: "Software Testing, Automation",
        experience: "10+ years",
        bio: "David is a software testing expert specializing in automation frameworks and QA best practices.",
        pastWork: "Developed automated testing frameworks for global software enterprises."
      }
    ]
  },
  {
    id: 14,
    title: "Big Data & Apache Spark",
    image: "https://img.freepik.com/free-photo/message-with-abstract-background_1134-422.jpg?t=st=1742120216~exp=1742123816~hmac=acd23940bc2306cf3e78494268bb3619afeae9bd96572f369e2233279b7a4698&w=1380",
    rating: 4.8,
    reviews: 2500,
    lessons: 18,
    duration: "50h 0m",
    level: "Advanced",
    quizzes: 95,
    certifications: "Yes",
    graduation: "21K",
    author: "Hari Babu",
    originalPrice: 480,
    discountedPrice: 200,
    description: "Master Big Data analytics using Apache Spark and Hadoop ecosystem.",
    features: [
      "Introduction to Big Data and Hadoop.",
      "Processing large-scale datasets with Apache Spark.",
      "Real-time analytics with Spark Streaming.",
      "Hands-on projects with real-world datasets."
    ],
    skills: [
      "Big Data Processing",
      "Apache Spark and Hadoop",
      "Streaming Data Analytics",
      "Distributed Computing"
    ],
    curriculum: [
      {
        title: "Introduction to Big Data & Hadoop",
        lessons: ["Hadoop, Spark, Kafka", "Data pipeline & real-time processing"]
      }
    ],
    curriculumFile: "/coursepdf/Big Data & Apache Spark.pdf",
    instructors: [
      {
        name: "Dr. Richard Stallman",
        expertise: "Big Data, Cloud Analytics",
        experience: "15+ years",
        bio: "Dr. Stallman has extensive experience in Big Data analytics and distributed computing.",
        pastWork: "Developed large-scale data pipelines for multinational corporations."
      }
    ]
  },
  {
    id: 15,
    title: "Prompt Engineering & AI-Powered Automation",
    image: "https://img.freepik.com/free-photo/programming-background-with-html_23-2150038862.jpg?t=st=1742120277~exp=1742123877~hmac=f24ab4091285ae7ecbdb05f2da36c101863645b3e65544e849d35127acdaf770&w=1380",
    rating: 4.9,
    reviews: 2700,
    lessons: 20,
    duration: "55h 0m",
    level: "Advanced",
    quizzes: 100,
    certifications: "Yes",
    graduation: "23K",
    author: "Ganesh",
    originalPrice: 500,
    discountedPrice: 220,
    description: "Learn the art of prompt engineering and AI-driven automation techniques.",
    features: [
      "Understanding AI and Natural Language Processing.",
      "Building efficient AI prompts for ChatGPT and LLMs.",
      "Automating workflows using AI-based tools.",
      "Real-world projects in AI-powered automation."
    ],
    skills: [
      "AI Prompt Engineering",
      "Automation with AI-powered APIs",
      "Natural Language Processing",
      "Building AI Chatbots and Assistants"
    ],
    curriculum: [
      {
        title: "Introduction to AI-Powered Automation",
        lessons: ["ChatGPT & AI tools for development", "Business automation with AI models"]
      }
    ],
    curriculumFile: "/coursepdf/Prompt Engineering & AI-Powered Automation – Detailed Syllabus.pdf",
    instructors: [
      {
        name: "Elena Watson",
        expertise: "AI Automation, NLP",
        experience: "12+ years",
        bio: "Elena is a leading expert in AI automation and has worked on cutting-edge NLP solutions.",
        pastWork: "Developed AI chatbots for top global enterprises."
      }
    ]
  },
  {
    id: 16,
    title: "UI/UX Design & Web Development",
    image: "https://img.freepik.com/free-vector/gradient-ui-ux-background_23-2149052117.jpg?t=st=1742119847~exp=1742123447~hmac=f8c4bbc38bf19ebda3857ff0bff1cec0e7ac025e26be70ecd55a3848e38a1a5b&w=1380",
    rating: 4.7,
    reviews: 2400,
    lessons: 16,
    duration: "45h 0m",
    level: "Intermediate",
    quizzes: 80,
    certifications: "Yes",
    graduation: "19K",
    author: "Shasi",
    originalPrice: 400,
    discountedPrice: 180,
    description: "Learn UI/UX design principles and web development best practices.",
    features: [
      "User research and wireframing techniques.",
      "Designing interactive prototypes with Figma and Adobe XD.",
      "Responsive web design with HTML, CSS, and JavaScript.",
      "Building modern, user-friendly web interfaces."
    ],
    skills: [
      "UI/UX Design Principles",
      "Web Design and Frontend Development",
      "User Research and Prototyping",
      "Building Responsive Web Interfaces"
    ],
    curriculum: [
      {
        title: "Fundamentals of UI/UX Design",
        lessons: ["Figma, Adobe XD, Sketch for UI design", "HTML, CSS, JavaScript for web development"]
      }
    ],
    curriculumFile: "/coursepdf/UI_UX Design Syllabus.pdf",
    instructors: [
      {
        name: "Sophia Martinez",
        expertise: "UI/UX Design, Frontend Development",
        experience: "10+ years",
        bio: "Sophia has designed intuitive user interfaces and experiences for global brands.",
        pastWork: "Worked on UI/UX projects for major e-commerce and tech companies."
      }
    ]
  }
];

const filters = [
  {
    id: "category",
    label: "Category",
    options: [
      { id: "all", label: "All" },
      { id: "art", label: "Art" },
      { id: "animation", label: "Animation" },
      { id: "design", label: "Design" },
      { id: "photography", label: "Photography" },
      { id: "programming", label: "Programming" },
      { id: "writing", label: "Writing" },
    ],
  },
  {
    id: "ratings",
    label: "Ratings",
    options: [
      { id: "all", label: "All" },
      { id: "4_5_up", label: "4.5 & up" },
      { id: "4_0_up", label: "4.0 & up" },
      { id: "3_5_up", label: "3.5 & up" },
      { id: "3_0_up", label: "3.0 & up" },
    ],
  },
  {
    id: "instructors",
    label: "Instructors",
    options: [
      { id: "all", label: "All" },
      { id: "jane_cooper", label: "Jane Cooper" },
      { id: "jenny_wilson", label: "Jenny Wilson" },
      { id: "robert_fox", label: "Robert Fox" },
      { id: "jacob_jones", label: "Jacob Jones" },
      { id: "albert_flores", label: "Albert Flores" },
    ],
  },
  {
    id: "price",
    label: "Price",
    options: [
      { id: "all", label: "All" },
      { id: "free", label: "Free" },
      { id: "paid", label: "Paid" },
    ],
  },
  {
    id: "level",
    label: "Level",
    options: [
      { id: "all", label: "All" },
      { id: "beginner", label: "Beginner" },
      { id: "intermediate", label: "Intermediate" },
      { id: "expert", label: "Expert" },
    ],
  },
  {
    id: "language",
    label: "Language",
    options: [
      { id: "all", label: "All" },
      { id: "english", label: "English" },
      { id: "french", label: "French" },
      { id: "german", label: "German" },
      { id: "italian", label: "Italian" },
    ],
  },
  {
    id: "duration",
    label: "Duration",
    options: [
      { id: "all", label: "All" },
      { id: "less_than_4", label: "Less than 4 hours" },
      { id: "4_to_7", label: "4 - 7 hours" },
      { id: "7_to_18", label: "7 - 18 hours" },
      { id: "20_plus", label: "20 + Hours" },
    ],
  },
];

function App() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);

  return (

    <>

<div className="floating-icons">
        <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
          <button

            className="sm_icon"
          >
            <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
          </button>
        </a>
        <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
          </button>
        </a>
        <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
          </button>
        </a>
        <a className="icon" href="https://wa.me/+918688964015" target="_blank">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
          </button>
        </a>
      </div>


      <div className="container-fluid courses_main_div">
        {/* <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-auto">
              <div className="breadcrumbs__content d-flex">
                <div className="breadcrumbs__item">
                  <Link to="/">Home</Link>
                </div>
                <div className="breadcrumbs__item">
                  <Link to="/user-courses">All Courses</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
        <section className="container-fluid mt-5">
          <div className="row y-gap-50">
            {/* <div className="col-xl-3 col-lg-4 col-md-none">
              <div className="pr-30 lg:pr-0">
                <div className="sidebar -courses">
                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Category</h5>
                          <div className="accordion__icon">
                            <button
                              data-toggle="collapse"
                              data-target="#category"
                            >
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="category"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[0].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-checkbox">
                                    <input type="checkbox" checked />
                                    <div className="form-checkbox__mark">
                                      <div className="form-checkbox__icon icon-check"></div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (6)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Ratings</h5>
                          <div className="accordion__icon">
                            <button data-toggle="collapse" data-target="#ratings">
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="ratings"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[1].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-radio mr-10">
                                    <div className="radio">
                                      <input type="radio" checked />
                                      <div className="radio__mark">
                                        <div className="radio-icon"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title d-flex items-center">
                                    <div className="d-flex x-gap-5 pr-10 mr-5">
                                      <div className="icon-star text-11 text-yellow-1 ">
                                        <i class="ri-star-fill"></i>
                                      </div>
                                      <div className="icon-star text-11 text-yellow-1 ">
                                        <i class="ri-star-fill"></i>
                                      </div>
                                      <div className="icon-star text-11 text-yellow-1 ">
                                        <i class="ri-star-fill"></i>
                                      </div>
                                      <div className="icon-star text-11 text-yellow-1 ">
                                        <i class="ri-star-fill"></i>
                                      </div>
                                      <div className="icon-star text-11 text-yellow-1 ">
                                        <i class="ri-star-fill"></i>
                                      </div>
                                    </div>
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (10)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />
                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Instructors</h5>
                          <div className="accordion__icon">
                            <button
                              data-toggle="collapse"
                              data-target="#instructor"
                            >
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="instructor"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[2].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-checkbox">
                                    <input type="checkbox" checked />
                                    <div className="form-checkbox__mark">
                                      <div className="form-checkbox__icon icon-check"></div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (7)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Price</h5>
                          <div className="accordion__icon">
                            <button data-toggle="collapse" data-target="#price">
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="price"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[3].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-radio mr-10">
                                    <div className="radio">
                                      <input type="radio" checked />
                                      <div className="radio__mark">
                                        <div className="radio-icon"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title d-flex items-center">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (10)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Level</h5>
                          <div className="accordion__icon">
                            <button data-toggle="collapse" data-target="#level">
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="level"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[4].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-checkbox">
                                    <input type="checkbox" checked />
                                    <div className="form-checkbox__mark">
                                      <div className="form-checkbox__icon icon-check"></div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (3)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="sidebar__item">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Language</h5>
                          <div className="accordion__icon">
                            <button
                              data-toggle="collapse"
                              data-target="#language"
                            >
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="language"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[5].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-checkbox">
                                    <input type="checkbox" checked />
                                    <div className="form-checkbox__mark">
                                      <div className="form-checkbox__icon icon-check"></div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (7)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="sidebar__item mb-4">
                    <div className="accordion js-accordion">
                      <div className="accordion__item js-accordion-item-active is-active ">
                        <div className="accordion__button items-center">
                          <h5 className="sidebar__title">Duration</h5>
                          <div className="accordion__icon">
                            <button
                              data-toggle="collapse"
                              data-target="#duration"
                            >
                              <i class="ri-arrow-down-wide-line"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          className="accordion__content"
                          id="duration"
                          style={{ maxHeight: "350px" }}
                        >
                          <div className="accordion__content__inner">
                            <div className="sidebar-checkbox">
                              {filters[6].options.map((label) => (
                                <div
                                  className="sidebar-checkbox__item mb-2"
                                  key={label.id}
                                >
                                  <div className="form-checkbox">
                                    <input type="checkbox" checked />
                                    <div className="form-checkbox__mark">
                                      <div className="form-checkbox__icon icon-check"></div>
                                    </div>
                                  </div>
                                  <div className="sidebar-checkbox__title">
                                    {label.label}
                                  </div>
                                  <div className="sidebar-checkbox__count">
                                    (3)
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="sidebar__more mt-15">
                              <Link className="text-14 fw-500 underline text-purple-1">
                                See more...
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-12">
              {/* <div className="accordion js-accordion mb-4">
                <div className="accordion_item">
                  <div className="row sort_by y-gap-20 items-center justify-between pb-30">
                    <div className="col-auto">
                      <div className="text-14 lh-12">
                        {" "}
                        Showing
                        <span class="text-dark-1 fw-500"> 43</span> total results
                      </div>
                    </div>
                    <div className="col-auto">
                      <div className="row x-gap-20 y-gap-20">
                        <div className="col-auto">
                          <div className="d-flex items-center">
                            <div className="text-14 lh-12 fw-500 text-dark-1 mr-20">
                              Sort by:
                            </div>
                            <div className="dropdown js-dropdown js-category-active">
                              default
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="row y-gap-30 side-content__wrap">
                {courses.map((course) => (
                  <CourseCard key={course.id} course={course} />
                ))}
              </div>

              {/* <Paginations /> */}
            </div>
          </div>
        </section>
      </div>

    </>
  );
}

export default App;
